import { useState } from 'react';
import Modal from './Modal';
import { exportConversations } from '../api/client';
import './ExportConversationsModal.css';

const FORMATS = [
  { id: 'pdf', label: 'PDF' },
  { id: 'json', label: 'JSON' },
  { id: 'both', label: 'Both' },
];

function formatDateRange(startDate, endDate) {
  if (!startDate && !endDate) return 'All time';
  return `${startDate || 'Earliest'} – ${endDate || 'today'}`;
}

/**
 * Confirms the destination email + export format, then asks the server to
 * build the export and email it — the export itself never touches the
 * browser, only the confirmation does.
 */
export default function ExportConversationsModal({ email, startDate, endDate, onClose }) {
  const [format, setFormat] = useState('both');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);

  async function handleConfirm() {
    setSending(true);
    setError('');
    try {
      const data = await exportConversations({ format, startDate, endDate });
      setResult(data);
    } catch (err) {
      setError(err.message || 'Failed to send export');
    } finally {
      setSending(false);
    }
  }

  if (result) {
    return (
      <Modal title="Export sent" onClose={onClose}>
        <p className="export-modal-text">
          Sent {result.count} conversation{result.count === 1 ? '' : 's'} to <strong>{result.sentTo}</strong>. It
          should arrive shortly.
        </p>
        <div className="export-modal-actions">
          <button className="export-btn-primary" onClick={onClose}>
            Done
          </button>
        </div>
      </Modal>
    );
  }

  return (
    <Modal title="Export conversations" onClose={onClose}>
      <p className="export-modal-text">
        We'll email your conversations to <strong>{email}</strong>.
      </p>
      <p className="export-modal-subtext">Date range: {formatDateRange(startDate, endDate)}</p>

      <div className="export-format-group" role="radiogroup" aria-label="Export format">
        {FORMATS.map((f) => (
          <label key={f.id} className={`export-format-option ${format === f.id ? 'export-format-option--active' : ''}`}>
            <input
              type="radio"
              name="export-format"
              value={f.id}
              checked={format === f.id}
              onChange={() => setFormat(f.id)}
            />
            {f.label}
          </label>
        ))}
      </div>

      {error && <p className="export-modal-error">{error}</p>}

      <div className="export-modal-actions">
        <button className="export-btn-secondary" onClick={onClose} disabled={sending}>
          Cancel
        </button>
        <button className="export-btn-primary" onClick={handleConfirm} disabled={sending}>
          {sending ? 'Sending…' : 'Send export'}
        </button>
      </div>
    </Modal>
  );
}
